import { FC } from 'react';

import { GridPaginationModel } from '@thirdspacelearning/library';

import { getFiltersMap } from '../../utils';

import { useCurriculumYears } from '@hooks';
import { Filters } from '@shared';
import { Country, LearningObjectiveType, SearchParams, Year } from '@types';

type Props = {
    country: Country;
    years: Year[];
    searchParams: SearchParams;
    setSearchParams: (params: SearchParams) => void;
    paginationModel: GridPaginationModel;
    setPaginationModel: (paginationModel: GridPaginationModel) => void;
};

const ProgrammeLoFilters: FC<Props> = ({
    country,
    years,
    searchParams,
    setSearchParams,
    paginationModel,
    setPaginationModel,
}) => {
    const { yearsMap } = useCurriculumYears(years);

    const filtersMap: Record<Country, any> = getFiltersMap(
        searchParams.type as LearningObjectiveType,
        yearsMap,
        years,
    );

    const filters = filtersMap[country];

    return (
        <Filters
            key={'filters'}
            filters={filters}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            resetFiltersOn={country}
        />
    );
};

export default ProgrammeLoFilters;
